import useCallbackAsync from 'hooks/useCallbackAsync';
import { getIsRfiStatusClosed } from '../utils';
import dataRoomApi from '../dataRoomApi';
import { DataRoomRFI } from '../models/DataRoomRfi';
import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';

const useRfiChangeStatus = (
  rfi: DataRoomRFI,
  onRfiUpdate: (rfi: DataRoomRFI) => void,
) => {
  const { _id, status } = rfi || {};

  const { t } = useTranslation();

  const { popSuccess } = useContext(PopNotificationsContext);

  const [changeStatus, loading] = useCallbackAsync(async () => {
    const isClosed = getIsRfiStatusClosed(status);

    const { data } = await dataRoomApi.rfi[isClosed ? 'reopenRfi' : 'closeRfi'](
      _id,
    );

    onRfiUpdate(data);
    popSuccess(t(isClosed ? 'rfiReopened' : 'rfiClosed'));
  });

  return { changeStatus, loading };
};

export default useRfiChangeStatus;
